<template>
    <router-link class="meeting-box" :to="{ name: 'sessionEdit', params: { sessionid: id, groupid: groupid },}">
        <section class="meeting-box__left">
            <h4 class="meeting-box__title">
                <span>
                    {{ name }}
                    <span v-if="number"> {{$t('com.file.meeting.nr')}} {{number !== null ? numberConversion(number) : "0"}} </span>
                </span>

                <span class="groups">{{getGroupsNames(groups)}}</span>
            </h4>
        </section> 
        <section class="meeting-box__right">
            <section class="meeting-box__info-box">
                <img src="@/assets/icons/panel/home/callendar.svg" class="meeting-box__icon" />
                <span v-if="!hasAdditionalTerms" class="meeting-box__info-text meeting-box__info-text--date">{{ getDate(dateTime, endDateTime) }},  {{ getTime(dateTime) }}</span>
                <span v-else class="meeting-box__info-text meeting-box__info-text--date">
                    <span v-for="(term, index) in termsToDisplay" :key="index" class="meeting-box__term">{{ term }}</span>
                </span>
                <img v-if="!isPublic && !isAuthorized" src="@/assets/icons/panel/home/eye-slash.svg" class="meeting-box__icon meeting-box__icon-status"  style="color:red" v-tooltip="$t('com.file.meeting.session-hide')" />
                <img v-if="!isPublic && isAuthorized" src="@/assets/icons/panel/home/eye.svg" class="meeting-box__icon meeting-box__icon-status" v-tooltip="$t('com.file.meeting.session-show-for-users')" />
                <img v-if="isPublic" src="@/assets/icons/panel/home/globe.svg" class="meeting-box__icon meeting-box__icon-status" v-tooltip="$t('com.file.meeting.session-public')" />
            </section>
            <section class="meeting-box__place" v-if="place" v-tooltip=place>
                <img src="@/assets/icons/panel/editSession/location-dot.svg" class="meeting-box__icon" />
                <span>{{ place }}</span>
            </section>
            <section class="meeting-box__portal">
                <ResidentPortalSessionLink :isPublic="isPublic" :code="code" />
            </section>
            <!--<section class="meeting-box__info-box">
                <img src="../../../../../assets/icons/panel/home/time.svg"
                     class="meeting-box__icon" />
                <span class="meeting-box__info-text">Godzina:</span>
            </section>-->
        </section>
    </router-link>
</template>

<script>
    import moment from "moment";
    import { sessionNumberConversion } from "../../../../../helpers/session.helper";
    import { formatDateToDisplay } from "@/helpers/i18n.utils";
    import { getSessionTerms } from "@/helpers/session.dates.helper";
    import ResidentPortalSessionLink from "@/components/BasicControls/ResidentPortalSessionLink.vue";
    export default {
        name: "Meeting",
        components: {
            ResidentPortalSessionLink,
        },
        props: {
            name: String,
            number: Number,
            dateTime: String,
            endDateTime: String,
            additionalDateTimes: Array,
            id: Number,
            groupid: Number,
            groupNumeration: Number,
            groups: Array,
            isPublic: Boolean,
            isAuthorized: Boolean,
            place: String,
            code: String
        },
        computed: {
            hasAdditionalTerms() {
                return (this.additionalDateTimes ?? []).length > 0;
            },
            // posiedzenie z wieloma terminami - zamiast zakresu "od - do" wypisujemy kazdy termin
            termsToDisplay() {
                return getSessionTerms({
                    meeting_date: this.dateTime,
                    additional_meeting_dates: this.additionalDateTimes,
                }).map((term) => `${formatDateToDisplay(term, "weekdayDate")}, ${moment(term).format("LT")}`);
            },
        },
        methods: {
            getGroupsNames(groups) {
                if (groups != null && groups.length > 0) {
                    var grName = '(';
                    for (var i = 0; i < groups.length; i++) {
                        grName += groups[i].name + ', ';
                    }
                    grName = grName.replace(/,\s*$/, "");
                    grName += ')';

                    return grName;
                }

                return '';
            },
            getDate(dateTime, endDateTime) {

                if (endDateTime !== null) {
                    let splitedMeetingDate = dateTime.split("T")[0];
                    let splitedEndMeetingDate = endDateTime.split("T")[0];
                    let meetingDate = new Date(splitedMeetingDate);
                    let endMeetingDate = new Date(splitedEndMeetingDate);
                    let diff = Math.abs(endMeetingDate - meetingDate);
                    const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));

                    if (diffDays === 0)
                        return `${formatDateToDisplay(dateTime, "weekdayDate")}`;
                    else
                        return `${formatDateToDisplay(dateTime, "weekdayDayMonthNumber")} - ${formatDateToDisplay(endDateTime, "dayMonthYear")}`;
                }
                else {
                    return `${formatDateToDisplay(dateTime, "weekdayDate")}`;
                }

                //const day = moment(dateTime).format("dddd");
                //const full_date = moment(dateTime).format("DD.MM.YYYY");

                //return `${day}, ${full_date}`;
            },
            getTime(dateTime) {
                const hour = moment(dateTime).format("LT");
                return hour;
            },
            numberConversion(index) {
                return sessionNumberConversion(this.groupNumeration, index);
            }
        },
    };
</script>

<style lang="scss" scoped>



    .red {
        color: red;
    }

    .meeting-box {
        display: flex;
        align-items: self-start;
        justify-content: space-between;
        gap: 20px;
        background: #ffffff;
        border: 1px solid #dce4ee;
        box-sizing: border-box;
        box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
        border-radius: 12px;
        padding: 19px 28px;
        margin-top: 12px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        .groups {
            font-weight: 300;
            font-size: 0.8em;
        }
        &:hover {
            background: #f4f6fa;
            border: 1px solid #bbc2ce;
            box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
        }

        &__title {
            font-weight: 600;
            font-size: 16px;
            line-height: 132%;
            color: #00082c;
            display: flex;
            flex-direction: column;
        }

        &__under-text {
            font-size: 14px;
            line-height: 145%;
            color: #333956;
        }

        &__right {
            display: flex;
            flex-direction: column;
            flex: 0 0 280px;
            gap: 5px;
        }

        &__place,
        &__info-box {
            display: flex;
            align-items: center;
            gap: 10px;
            justify-content: start;
        }

        &__icon {
            width: 18px;
            height: 18px;
        }

        &__icon-status{
            margin-left: auto;
        }

        &__place,
        &__info-text {
            font-weight: 500;
            font-size: 14px;
            line-height: 145%;
            color: #00082c;

            &--date::first-letter {
                text-transform: uppercase;
            }
        }

        &__place{
        }

        // pusta sekcja (portal nieaktywny albo posiedzenie bez kodu) nie moze dokladac odstepu w kolumnie
        &__portal:empty {
            display: none;
        }

        &__term {
            display: block;

            &::first-letter {
                text-transform: uppercase;
            }
        }
    }
</style>
